import React, {FC, useState} from "react"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"
import {Col} from "@irati/ui/src/ColumnRow"
import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"
import AddressInfoSection from "./AddressInfoSection"

interface Props extends WithBasket {
  onEditClick: () => void,
  load?: Promise<any>,
  onPlaceOrderClick: () => void
}

const MobileFlex = styled(Flex)`
  background-color: ${({theme}) => theme.colors.greys.white};
  padding: ${({theme}) => theme.spacing.two};
`

const OrderAddressInfo: FC<Props> = (props) => {
  const [termsAgreed, setTermsAgreed] = useState(false)

  const addressInfoSection = (
    <AddressInfoSection
      {...props}
      termsAgreed={termsAgreed}
      toggleTermsAgreed={() => setTermsAgreed(!termsAgreed)} />
  )

  return (
    <>
      {/* Desktop */}
      <Col md={12} lg={6} xsHidden>
        {addressInfoSection}
      </Col>

      {/* Mobile */}
      <Col smHidden mdHidden lgHidden>
        <MobileFlex>
          {addressInfoSection}
        </MobileFlex>
      </Col>
    </>
  )
}

export default withBasket(OrderAddressInfo)
